// PAB Hero — auto-rotating value-prop carousel (5s default, honors reduced motion).
class PabHero extends HTMLElement {
  #timer = null;
  #idx = 0;

  connectedCallback() {
    this.track = this.querySelector('[data-pab-track]');
    this.dots = [...this.querySelectorAll('[data-pab-dot]')];
    this.n = this.track ? this.track.children.length : 0;
    if (!this.track || this.n === 0) return;

    this.querySelector('[data-pab-prev]')?.addEventListener('click', () => this.#go(this.#idx - 1));
    this.querySelector('[data-pab-next]')?.addEventListener('click', () => this.#go(this.#idx + 1));
    this.dots.forEach((d) => d.addEventListener('click', () => this.#go(Number(d.dataset.index))));
    this.#start();
  }

  disconnectedCallback() {
    if (this.#timer) clearInterval(this.#timer);
  }

  #start() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (this.#timer) clearInterval(this.#timer);
    const interval = Number(this.dataset.interval) || 5000;
    this.#timer = setInterval(() => this.#set((this.#idx + 1) % this.n), interval);
  }

  #go(i) {
    this.#set((i + this.n) % this.n);
    this.#start(); // reset the timer on manual navigation, like the design
  }

  #set(i) {
    this.#idx = i;
    this.track.style.transform = `translateX(-${i * 100}%)`;
    this.dots.forEach((d, j) => d.classList.toggle('on', j === i));
  }
}

if (!customElements.get('pab-hero')) customElements.define('pab-hero', PabHero);
